<template>
  <pre v-if="model.$diff" v-html="diffText"></pre>
  <div v-else style="white-space: pre-wrap;">{{model.$value}}</div>
</template>
<script>
export default {
  props: ['model'],
  computed: {
    diffText() {
      return diff(this.model.$prevValue, this.model.$newValue);
    }
  }
};
</script>


